// Gift Card functionality: QR code generation and clipboard copy
// Assumes QRCode library is loaded globally (e.g., via CDN or as a global script)

document.addEventListener('calpak:loaded', function() {
  if (!document.querySelector('.template-gift_card')) return;

  // Clipboard copy functionality
  const copyButtons = document.querySelectorAll('.js-giftcard-code-copy');
  copyButtons.forEach(function(copyButton) {
    copyButton.addEventListener('click', function() {
      const code = copyButton.closest('.giftcard__code__inner').querySelector('.giftcard__code__text').textContent.trim();

      // Try to use the Clipboard API
      if (navigator.clipboard) {
        navigator.clipboard.writeText(code).then(function() {
          showCopiedFeedback(copyButton);
        }, function() {
          fallbackCopyTextToClipboard(code, copyButton);
        });
      } else {
        fallbackCopyTextToClipboard(code, copyButton);
      }
    });
  });

  function showCopiedFeedback(button) {
    // Save original content
    const originalContent = button.innerHTML;
    button.classList.add('is-active');
    button.innerHTML = 'Copied!';
    setTimeout(function() {
      button.innerHTML = originalContent;
      button.classList.remove('is-active');
    }, 2000);
  }

  function fallbackCopyTextToClipboard(text, button) {
    const textArea = document.createElement('textarea');
    textArea.value = text;
    // Avoid scrolling to bottom
    textArea.style.position = 'fixed';
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();

    try {
      document.execCommand('copy');
      showCopiedFeedback(button);
    } catch (err) {
      alert('Failed to copy code');
    }
    document.body.removeChild(textArea);
  }
}); 